import { API, api } from "./api";

export const BASE_FONTS = [
  { value: "serif", label: "Classic Serif", css: "Georgia, 'Times New Roman', serif" },
  { value: "playfair", label: "Playfair Display", css: "'Playfair Display', serif" },
  { value: "cormorant", label: "Cormorant Garamond", css: "'Cormorant Garamond', serif" },
  { value: "baskerville", label: "Libre Baskerville", css: "'Libre Baskerville', serif" },
  { value: "sans", label: "Modern Sans", css: "'IBM Plex Sans', Arial, sans-serif" },
  { value: "poppins", label: "Poppins", css: "Poppins, sans-serif" },
  { value: "lato", label: "Lato", css: "Lato, sans-serif" },
  { value: "script", label: "Great Vibes (script)", css: "'Great Vibes', cursive" },
];

export const FONT_CSS = Object.fromEntries(BASE_FONTS.map((f) => [f.value, f.css]));

export const customKey = (id) => `custom_${id}`;
export const faceFamily = (font) => `LICustom-${font.id}`;

let customCache = [];
const listeners = new Set();
const loadedFaces = new Set();

export function getCustomFonts() {
  return customCache;
}

export function onFontsChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function notify() {
  listeners.forEach((fn) => fn(customCache));
}

export function fontCss(key) {
  if (key && FONT_CSS[key]) return FONT_CSS[key];
  if (key && key.startsWith("custom_")) {
    const cf = customCache.find((f) => customKey(f.id) === key);
    if (cf) return `'${faceFamily(cf)}', Georgia, serif`;
  }
  return FONT_CSS.serif;
}

export function fontLabel(key) {
  const b = BASE_FONTS.find((f) => f.value === key);
  if (b) return b.label;
  const cf = customCache.find((f) => customKey(f.id) === key);
  return cf ? cf.name : key || "Classic Serif";
}

export async function refreshCustomFonts() {
  try {
    const { data } = await api.get("/fonts");
    customCache = data || [];
    await Promise.all(
      customCache.map(async (f) => {
        const fam = faceFamily(f);
        if (loadedFaces.has(fam)) return;
        try {
          const face = new FontFace(fam, `url("${API}/fonts/${f.id}/file") format("truetype")`);
          await face.load();
          document.fonts.add(face);
          loadedFaces.add(fam);
        } catch (err) {
          console.warn(`Font preview failed for ${f.name} — falling back to serif:`, err);
        }
      })
    );
    notify();
  } catch (err) {
    console.warn("Could not load custom fonts — keeping previous cache:", err);
  }
  return customCache;
}
